import React from 'react';
import { connect } from 'react-redux';
import { mapFinalFormErrors } from '../../lib/utils.js';
import { signInAndRestore } from '../../modules/auth.js';
import { selectSessionExpired } from '../../modules/auth.js';
import SessionExpiredModal from '../../components/auth/SessionExpiredModal.jsx';

const mapErrors = mapFinalFormErrors('Failed to sign in');

const getOrgSlug = () => {
  const segments = window.location.pathname.split('/').filter(Boolean);
  return segments[0] || null;
};

let SessionExpiredModalContainer = ({ show, signInAndRestore }) => {
  const onSignIn = (values) => {
    return signInAndRestore(values, getOrgSlug()).catch(mapErrors);
  };

  return <SessionExpiredModal show={show} onSignIn={onSignIn} />;
};

const mapStateToProps = (state) => ({
  show: selectSessionExpired(state),
});

SessionExpiredModalContainer = connect(mapStateToProps, { signInAndRestore })(
  SessionExpiredModalContainer
);

export default SessionExpiredModalContainer;
